import React, { useEffect } from "react";
import Form from "../components/Form";
import Poster from "../components/Poster";
import useEventState from "../hooks/eventHooks";

function FormPage() {
  const { addAttendee, getLatestEvent, latestEvent, setLatestEvent } =
    useEventState();

  useEffect(() => {
    getLatestEvent();
  }, []);

  // get from local storage
  useEffect(() => {
    const event = JSON.parse(localStorage.getItem("lastest_event"));
    if (event) {
      setLatestEvent(event);
    }
  }, []);

  return (
    <div className="mt-2 lg:justify-normal justify-center lg:p-0 p-6">
      <div className="w-full lg:h-[66rem] lg:flex">
        <Poster poster={latestEvent.poster} />
        <div className="w-full h-full lg:px-5">
          <div className="w-full text-center">
            <h3 className="text-3xl capitalize">{latestEvent.name}</h3>
            <p className="mt-1 capitalize">{latestEvent.edition}</p>
          </div>
          <Form addAttendee={addAttendee} eventId={latestEvent.id} />
        </div>
      </div>
    </div>
  );
}

export default FormPage;
